import { ICreateSubscriptionManagement } from './types'
import { getData } from '../get-table'
import { HttpService } from '../http.service'
export * from './types'

const http = new HttpService()

/**
 * Consultas generales
 */
export async function getTriggers(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = []
  if (search) {
    where.push(`CONCAT(name,endpoint,description) ILIKE '%${search}%'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = ['order by updated_at desc'])
  // result
  const response: any = await getData({
    tables: ['pg_triggers'],
    fields: [
      'id',
      'name',
      'endpoint',
      'events',
      'description',
      'headers',
      'updated_at'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })

  return response
}

export async function getTrigger(id: string): Promise<any> {
  const data = await getData<any>({
    tables: ['pg_triggers'],
    fields: [
      'id',
      'name',
      'endpoint',
      'events',
      'description',
      'headers',
      'updated_at'
    ],
    where: [`id = '${id}'`],

    options: {
      outputFormat: 'json'
    }
  })
  return data[0].results[0]
}

export async function createSubscriptionManagement(
  data: ICreateSubscriptionManagement
): Promise<string> {
  const response: any = await http.post('/triggers ', {
    name: data.name,
    description: data.description,
    endpoint: data.endpoint,
    events: data.events,
    headers: data.headers
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function updateSubscriptionManagement(
  data: ICreateSubscriptionManagement,
  id: string
): Promise<string> {
  const response: any = await http.put('triggers/' + id, {
    name: data.name,
    description: data.description,
    endpoint: data.endpoint,
    events: data.events,
    headers: data.headers
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function deleteSubscriptionManagement(
  id: string
): Promise<boolean> {
  const response: any = await http.delete('triggers/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
